import React from 'react'
import { Maybe } from 'graphql/jsutils/Maybe'
import { PaddedContainer } from '@/atoms/PaddedContainer'
import { DISCOVER_TABS_SLUGS } from '@/molecules/CategoryTabs'
import { FaqSection } from '@/organisms/FaqSection'
import { Page } from '@/page'
import { PageDataContext, PageModel } from '@/services/RenderService'

export interface DiscoverPageViewProps {
  pageDataContext: Maybe<PageDataContext>
  page: Maybe<PageModel>
  discoverySlug?: string
}

export const DiscoverPageView: React.FC<DiscoverPageViewProps> = ({ pageDataContext, page, discoverySlug }) => {
  const showTabs = Boolean(
    discoverySlug && DISCOVER_TABS_SLUGS.includes(discoverySlug as (typeof DISCOVER_TABS_SLUGS)[number]),
  )

  return (
    <main className="overflow-x-hidden bg-core-gray-950 pt-24 text-white lg:pt-0">
      <div className="flex flex-col gap-y-12 md:pt-4 lg:pt-0">
        {!!page && !!pageDataContext && (
          <Page
            page={page}
            pageDataContext={{
              ...pageDataContext,
              contentItemConfig: {
                padding: true,
                showThumbnailTitleDescription: true,
                discoverTabs: showTabs,
                discoverTabsActiveSlug: discoverySlug,
              },
            }}
          />
        )}
        <PaddedContainer fluid>
          <FaqSection />
        </PaddedContainer>
      </div>
    </main>
  )
}
